import {CounterLabel} from '@primer/react'
import {useChangesetFileCount} from '../../hooks/use-changeset-file-count'

/**
 * Live file-count badge for the diff workbench's browser tab (`ContentPreviewTab`'s
 * `trailingComponent` slot) — e.g. "Changed files [19]". Renders nothing until the changeset
 * settles, so the tab doesn't flash a "0" badge while the count is still loading.
 */
export function DiffWorkbenchTabBadge() {
  const {isReady, fileCount} = useChangesetFileCount(true)
  if (!isReady) return null
  return <CounterLabel>{fileCount}</CounterLabel>
}
